<template>
  <div
    :class="
      `wd-100p bg-white unselectable ${
        propExamId > 0 ? 'ht-80v' : 'pos-fixed ht-100v'
      }`
    "
  >
    <div class="content pd-0 bd-b">
      <div
        :class="
          `container-fluid ${this.$store.state.app.isMobile ? 'pd-0-f' : ''}`
        "
      >
        <div class="row no-gutters">
          <div
            :class="
              `${
                this.$store.state.app.isMobile || propExamId > 0
                  ? 'd-none'
                  : 'col-2'
              } bd-r`
            "
            :style="`height: calc(${propExamId > 0 ? '80' : '100'}vh - 55px)`"
          >
            <div class="d-flex bd-b pd-b-5 mg-b-10">
              <div class="avatar">
                <img
                  :src="$store.state.user.userInfo.avator"
                  class="rounded-circle"
                  alt
                />
              </div>
              <div class="mg-l-10">
                <h6 class="tx-semibold mg-b-0">
                  <feather type="user" class="ht-15-f wd-15-f mg-r-5"></feather
                  >{{ $store.state.user.userInfo.fullName }}
                </h6>
                <h6 class="tx-color-03 tx-12 mg-b-0">
                  <feather
                    type="credit-card"
                    class="ht-15-f wd-15-f mg-r-5"
                  ></feather
                  >{{ $store.state.user.userInfo.register }}
                </h6>
                <h6 class="tx-color-03 tx-12 mg-b-0">
                  <feather type="phone" class="ht-15-f wd-15-f mg-r-5"></feather
                  >{{ $store.state.user.userInfo.mobile }}
                </h6>
                <h6 class="tx-color-03 tx-12 mg-b-0">
                  <feather
                    type="at-sign"
                    class="ht-15-f wd-15-f mg-r-5"
                  ></feather
                  >{{ $store.state.user.userInfo.mail }}
                </h6>
                <p class="tx-color-03 tx-12 mg-b-0">
                  <feather type="home" class="ht-15-f wd-15-f mg-r-5"></feather
                  >{{ $store.state.user.userInfo.groupName }}
                </p>
                <p class="tx-color-03 tx-12 mg-b-0">
                  <feather
                    type="briefcase"
                    class="ht-15-f wd-15-f mg-r-5"
                  ></feather
                  >{{ $store.state.user.userInfo.position }}
                </p>
              </div>
            </div>
            <div v-if="mode == 2" class="text-center">
              <div class="tx-thin mg-b-5">шалгалт дуусахад</div>
              <vue-countdown
                @progress="timerProgress"
                @end="finishForm(false)"
                :time="getSeconds(exam.End)"
                v-slot="{ days, hours, minutes, seconds }"
                >{{ days }} өдөр : {{ hours }} цаг : {{ minutes }} минут :
                {{ seconds }} секунд</vue-countdown
              >
              <div class="mg-t-10">
                <button
                  @click="busy = true"
                  class="btn btn-xs btn-outline-danger"
                  type="button"
                >
                  Шалгалтыг дуусгах
                </button>
              </div>

              <div class="container-fluid pd-y-10 bd-y mg-y-10">
                <div class="row" :key="fillingKey">
                  <div
                    :class="`d-flex align-items-center mg-b-5`"
                    style="width: 12.5%"
                    v-for="(q, qi) in exam.Questions"
                    :key="qi"
                  >
                    <div
                      :class="
                        `bd rounded-circle ${
                          q.isFilled ? 'bg-primary text-white' : 'bg-gray-100'
                        } tx-12 pd-5`
                      "
                    >
                      {{ qi + 1 >= 10 ? qi + 1 : "0" + (qi + 1) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            :class="
              `col-${
                this.$store.state.app.isMobile || propExamId > 0 ? '12' : '10'
              }`
            "
          >
            <div v-if="mode == 1" class="container ht-100p tx-center">
              <div
                class="
                  ht-100p
                  d-flex
                  flex-column
                  align-items-center
                  justify-content-center
                "
              >
                <div class="wd-70p wd-sm-250 wd-lg-300 mg-b-15">
                  <img src="assets/img/img16.png" class="img-fluid" alt />
                </div>
                <h1 class="tx-color-01 tx-24 tx-sm-32 tx-lg-36 mg-xl-b-5">
                  Түр хүлээнэ үү
                </h1>
                <h5 class="tx-16 tx-sm-18 tx-lg-20 tx-normal mg-b-20">
                  <vue-countdown
                    @end="configure()"
                    :time="getSeconds(exam.Start)"
                    v-slot="{ days, hours, minutes, seconds }"
                    >{{ days }} өдөр : {{ hours }} цаг : {{ minutes }} минут :
                    {{ seconds }} секунд</vue-countdown
                  >
                </h5>
                <p class="tx-color-03 mg-b-30">Шалгалт эхлэхэд</p>
              </div>
            </div>
            <div v-else-if="mode == 2">
              <!-- {{exam}} -->
              <vue-custom-scrollbar
                :style="`height: ${examHeight}px; position: relative`"
              >
                <div v-for="(s, i) in exam.Sections" :key="i" class="mg-y-10">
                  <div class="pd-x-10">
                    <h6 class="tx-uppercase tx-semibold mg-b-0">
                      {{ romanize(i + 1) }}). {{ s.Name }}
                    </h6>
                    <div
                      v-if="
                        s.Info != undefined && s.Info != null && s.Info != ''
                      "
                      class="alert alert-warning fade show section-alert"
                      v-html="s.Info"
                    ></div>
                  </div>
                  <div class="pd-y-15">
                    <div
                      v-for="(q, i) in exam.Questions.filter(
                        x => x.sId == s.Id
                      )"
                      :key="i"
                      class="mg-b-20"
                    >
                      <div
                        class="
                          d-flex
                          align-items-center
                          tx-16
                          bd-y
                          bg-gray-100
                          pd-x-10
                        "
                      >
                        <div class="mg-r-10 text-muted">{{ i + 1 }}.</div>
                        <div v-if="q.t == 31" style="font-weight:500" class="pd-y-5">
                          <div v-html="generateMissingWords(q)"></div>
                        </div>
                        <div
                          v-else
                          v-html="q.q"
                          style="font-weight:500"
                        ></div>
                      </div>
                      <div
                        v-html="`Тайлбар: ${q.i}`"
                        v-if="q.i != undefined && q.i != null && q.i != ''"
                        class="pd-t-10 pd-x-10 bg-gray-100 text-muted"
                      ></div>

                      <div
                        :class="
                          `mg-x-${
                            $store.state.app.isMobile ? '5' : '30'
                          } mg-b-30`
                        "
                      >
                        <div
                          v-if="q.t == 31"
                          class="alert alert-light tx-13 mg-y-10"
                        >
                          Цэгийн оронд тохирох үгийг сонгоно уу
                        </div>
                        <div
                          v-else-if="q.t == 21"
                          class="input-group mg-t-10 wd-400"
                        >
                          <div class="input-group-prepend">
                            <span class="input-group-text">{{ q.tp }}</span>
                          </div>
                          <div class="form-control pd-0-f">
                            <input
                              type="number"
                              @keyup="fillForm(q, q.as[0], $event)"
                              v-model="q.as[0].s"
                              controls-position="right"
                              class="number-with-pend wd-100p el-input__inner"
                            />
                          </div>
                          <div class="input-group-append">
                            <span class="input-group-text">{{
                              q.as[0].s | formatMoney(2, ".", ",")
                            }}</span>
                          </div>
                        </div>
                        <div v-else-if="q.t == 1 || q.t == 11" class="mg-t-10">
                          <Input
                            @input="fillForm(q, q.as[0])"
                            v-model="q.as[0].s"
                            :type="`${q.t == 11 ? 'textarea' : 'text'}`"
                            :rows="q.t == 11 ? 3 : 0"
                            maxlength="4000"
                          />
                        </div>
                        <div v-else-if="q.t == 7" class="mg-t-10">
                          <input
                            class="el-input__inner"
                            type="number"
                            @keyup="fillForm(q, q.as[0], $event)"
                            v-model="q.as[0].s"
                          />
                          <button @click="q.isFilled = true">
                            Бөглөснөөр тэмдэглэх
                          </button>
                        </div>
                        <div v-else-if="q.t == 22" class="mg-t-10">
                          <DatePicker
                            @change="fillForm(q, q.as[0], $event)"
                            type="date"
                            style="width: 100%"
                            v-model="q.as[0].s"
                            :format="'yyyy-MM-dd'"
                            :value-format="'yyyy-MM-dd'"
                          ></DatePicker>
                        </div>
                        <div
                          v-else-if="
                            q.t == 3 || q.t == 4 || q.t == 23 || q.t == 24
                          "
                          @click="fillForm(q, a)"
                          v-for="(a, ai) in q.as"
                          :key="ai"
                          :class="`mg-t-10`"
                          role="button"
                        >
                          <div class="d-flex tx-14">
                            <div class="mg-r-10 tx-16">
                              <i
                                v-if="q.t == 3"
                                :class="
                                  `far fa-${a.if ? 'check-square' : 'square'}`
                                "
                              ></i>
                              <i
                                v-else
                                :class="
                                  `far fa-${a.if ? 'check-circle' : 'circle'}`
                                "
                              ></i>
                            </div>
                            <div class="mg-r-10">{{ alphabetize(ai) }}.</div>
                            <div v-html="a.a"></div>
                          </div>
                          <div v-show="q.t == 23 && a.if == true">
                            <Input
                              maxlength="4000"
                              @input="fillForm(q, a)"
                              v-model="a.s"
                              size="mini"
                              placeholder="Тайлбар бичнэ үү"
                              type="textarea"
                              :rows="3"
                            />
                          </div>
                          <div
                            v-show="
                              a.if == true && a.i != null && a.i.length > 0
                            "
                            class="
                              alert alert-outline alert-secondary
                              mg-l-20 mg-b-0
                              pd-x-10 pd-y-5
                              bd-1
                            "
                          >
                            {{ a.i }}
                          </div>
                        </div>
                        <div
                          v-else-if="q.t == 32 || q.t == 33"
                          style="overflow: hidden; max-width: 100%"
                        >
                          <div class="row">
                            <div :class="`col-${q.t == 33 ? '12' : '6'}`">
                              <ul class="list-group" v-if="q.t == 32">
                                <li
                                  v-for="(a, i) in sortedAnswers(q)"
                                  :key="i"
                                  class="
                                    list-group-item
                                    d-flex
                                    align-items-center
                                  "
                                >
                                  <div>{{ i + 1 }}.</div>
                                  <div
                                    v-if="a.if"
                                    class="
                                      mg-l-10
                                      bg-gray-100
                                      pd-y-5 pd-x-10
                                      bd
                                      rounded
                                    "
                                  >
                                    {{ a.a }}
                                  </div>
                                  <button
                                    @click="fillForm(q, a, 0)"
                                    class="
                                      btn btn-xs btn-icon btn-outline-light
                                      mg-l-auto
                                    "
                                  >
                                    <feather type="x"></feather>
                                  </button>
                                </li>
                              </ul>
                              <div v-else-if="q.t == 33" class="pyramid">
                                <div
                                  @click="fillForm(q, a, 0)"
                                  class="zone"
                                  v-for="(a, i) in sortedAnswers(q)"
                                  :key="i"
                                >
                                  <div v-if="a.if" class="pd-t-50">
                                    <div
                                      class="
                                        bg-white
                                        tx-color-02
                                        pd-y-5 pd-x-10
                                        bd
                                        pos-relative
                                      "
                                    >
                                      {{ a.a }}
                                      <button
                                        @click="fillForm(q, a, 0)"
                                        class="
                                          btn btn-xs btn-icon btn-outline-light
                                          mg-l-auto
                                        "
                                      >
                                        <feather type="x"></feather>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div :class="`col-${q.t == 33 ? '12' : '6'}`">
                              <ul class="list-group">
                                <li
                                  v-for="(a, i) in q.as.filter(x => !x.if)"
                                  :key="i"
                                  class="
                                    list-group-item
                                    d-flex
                                    align-items-center
                                  "
                                >
                                  <button
                                    @click="fillForm(q, a)"
                                    class="
                                      btn btn-xs btn-icon btn-outline-light
                                      mg-r-10
                                    "
                                  >
                                    <feather
                                      v-if="q.t == 32"
                                      type="chevron-left"
                                    ></feather>
                                    <feather
                                      v-else-if="q.t == 33"
                                      type="chevron-up"
                                    ></feather>
                                  </button>
                                  {{ a.a }}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div
                          v-else-if="q.t == 34 && q.as.length == 8"
                          :class="
                            `${
                              $store.state.app.isMobile
                                ? 'on-mobile'
                                : 'mg-l-20'
                            } pd-y-10`
                          "
                        >
                          <div class="wd-500" style="width: 510px">
                            <div class="row no-gutters square-group-loop-outer">
                              <div
                                class="col-6"
                                style="height: 210px"
                                v-for="(gl, gli) in 4"
                                :key="gli"
                              >
                                <div>
                                  <div class="drpdwn">
                                    <button
                                      class="btn btn-secondary dropdown-toggle"
                                      type="button"
                                      data-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="false"
                                    >
                                      {{
                                        q.as.filter(
                                          x => x.if && x.gg == gli + 1
                                        ).length
                                          ? q.as.filter(
                                              x => x.if && x.gg == gli + 1
                                            )[0].a
                                          : "-- сонгоно уу --"
                                      }}
                                    </button>
                                    <div style="width: 50vw"
                                      class="dropdown-menu"
                                      :ref="`${q.qId}_${gli}_mnu`"
                                    >
                                      <a @click="fillForm(q, null, 0, gli + 1)"
                                        >-- сонгоно уу --</a
                                      >
                                      <a style="white-space: break-spaces;"
                                        @click="fillForm(q, a, 0, gli + 1)"
                                        class="dropdown-item"
                                        role="button"
                                        v-for="(a, i) in q.as.filter(
                                          x =>
                                            x.o != 0 &&
                                            (x.gg == gli + 1 || x.gg == null)
                                        )"
                                        :key="i + '_' + gli"
                                        >{{ a.a }}</a
                                      >
                                    </div>
                                  </div>
                                  <div
                                    class="
                                      sction
                                      pos-absolute
                                      rounded
                                      wd-250
                                      ht-200
                                    "
                                    style="overflow: hidden"
                                  >
                                    <div
                                      class="
                                        cmbo
                                        pos-absolute
                                        bd
                                        pd-20
                                        ht-150
                                        wd-200
                                      "
                                    >
                                      <div
                                        class="dd pos-absolute"
                                        :ref="`${q.qId}_${gli}_cnt`"
                                      ></div>
                                    </div>
                                    <div
                                      class="
                                        dugui
                                        pos-absolute
                                        wd-300
                                        ht-300
                                        rounded-circle
                                        bd
                                      "
                                    >
                                      <div class="wd-150 txt pd-10">
                                        {{ q.as.filter(x => x.o == 0)[gli].a }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </vue-custom-scrollbar>
            </div>
            <div v-else-if="mode == 3" class="container ht-100p tx-center">
              <div
                class="
                  ht-100p
                  d-flex
                  flex-column
                  align-items-center
                  justify-content-center
                "
              >
                <div class="wd-70p wd-sm-250 wd-lg-300 mg-b-15">
                  <img src="assets/img/img17.png" class="img-fluid" alt />
                </div>
                <h1 class="tx-color-01 tx-24 tx-sm-32 tx-lg-36 mg-xl-b-5">
                  Шалгалт дууссан байна
                </h1>
                <p class="tx-color-03 mg-b-30">
                  Үр дүн амжилттай илгээлээ. Баярлалаа
                </p>
                <div class="d-flex mg-b-40">
                  <router-link
                    v-if="
                      $route.params.lessonId != undefined &&
                        $route.params.lessonId > 0
                    "
                    :to="
                      `/lms/lessonView/${$route.params.lessonId}/${mainCourseId}/${$route.params.boxId}/${mainFormId}/${$route.params.boxOt}`
                    "
                    class="btn btn-brand-02 bd-0 mg-l-5 pd-sm-x-25 text-white"
                    >Буцах</router-link
                  >
                  <router-link
                    v-else
                    :to="`/lms/courseView/${mainCourseId}/0/0/0`"
                    class="btn btn-brand-02 bd-0 mg-l-5 pd-sm-x-25 text-white"
                    >Эхлэл</router-link
                  >
                </div>
              </div>
            </div>
            <div v-else-if="mode == 5" class="container ht-100p tx-center">
              <div
                class="
                  ht-100p
                  d-flex
                  flex-column
                  align-items-center
                  justify-content-center
                "
              >
                <div class="wd-70p wd-sm-250 wd-lg-300 mg-b-15">
                  <img src="assets/img/img16.png" class="img-fluid" alt />
                </div>
                <h1 class="tx-color-01 tx-24 tx-sm-32 tx-lg-36 mg-xl-b-5">
                  Үр дүн илгээгдсэнгүй
                </h1>
                <p class="tx-color-03 mg-b-30">Дахин илгээнэ үү</p>
                <div class="d-flex mg-b-40">
                  <button
                    @click="finishForm(false)"
                    class="btn btn-brand-02 bd-0 mg-l-5 pd-sm-x-25 text-white"
                  >
                    Үр дүн илгээх
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer class="d-flex align-items-center ht-55 pd-x-10">
      <div
        v-if="mode == 2 && !$store.state.app.isMobile && propExamId == 0"
        :key="fillingKey"
        :class="
          `d-flex align-items-center justify-content-between ${
            $store.state.app.isMobile ? 'wd-50p' : 'wd-100p'
          }`
        "
      >
        <span class="tx-color-03"
          >Нийт: {{ exam.Questions.length }} асуулт. Бөглөсөн:
          {{ exam.Questions.filter(x => x.isFilled).length }}. Бөглөөгүй:
          {{ exam.Questions.filter(x => !x.isFilled).length }}</span
        >
        <div class="progress ht-20 wd-60p">
          <div
            class="progress-bar"
            :style="{
              width:
                (exam.Questions.filter(x => x.isFilled).length * 100) /
                  exam.Questions.length +
                '%'
            }"
          >
            {{
              (
                (exam.Questions.filter(x => x.isFilled).length * 100) /
                exam.Questions.length
              ).toFixed(2)
            }}%
          </div>
        </div>
        <div></div>
      </div>
      <div
        v-else-if="mode == 2 && $store.state.app.isMobile"
        class="pd-x-10 d-flex wd-100p align-items-center"
      >
        <div>
          <vue-countdown
            @progress="timerProgress"
            @end="finishForm(false)"
            class="text-primary"
            :time="getSeconds(exam.End)"
            v-slot="{ days, hours, minutes, seconds }"
            >{{ days }}ө : {{ hours }}ц : {{ minutes }}м :
            {{ seconds }}с</vue-countdown
          >
        </div>
        <div class="mg-l-auto btn-group">
          <button
            @click="showRightSide = true"
            class="btn btn-outline-light btn-xs"
          >
            Явц {{ exam.Questions.filter(x => x.isFilled).length }}/{{
              exam.Questions.length
            }}
          </button>
        </div>
      </div>
      <div
        v-else-if="mode == 2 && propExamId > 0"
        class="pd-x-10 d-flex wd-100p align-items-center"
      >
        <span class="tx-color-03"
          >Нийт: {{ exam.Questions.length }} асуулт. Бөглөсөн:
          {{ exam.Questions.filter(x => x.isFilled).length }}. Бөглөөгүй:
          {{ exam.Questions.filter(x => !x.isFilled).length }}</span
        >
        <div class="progress ht-20 wd-60p">
          <div
            class="progress-bar"
            :style="{
              width:
                (exam.Questions.filter(x => x.isFilled).length * 100) /
                  exam.Questions.length +
                '%'
            }"
          >
            {{
              (
                (exam.Questions.filter(x => x.isFilled).length * 100) /
                exam.Questions.length
              ).toFixed(2)
            }}%
          </div>
        </div>
        <div class="mg-l-auto btn-group">
          <button @click="finishForm(false)" class="btn btn-warning btn-xs">
            Дуусгах ?
          </button>
        </div>
      </div>
    </footer>

    <b-overlay :show="busy" no-wrap style="z-index: 2000">
      <template #overlay>
        <div
          v-if="processing"
          class="text-center p-4 bg-secondary text-light rounded"
        >
          <b-icon icon="info" font-scale="4"></b-icon>
          <div class="mb-3">Түр хүлээнэ үү...</div>
          <b-progress
            min="1"
            max="20"
            :value="18"
            variant="warning"
            height="5px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <div>
            <strong id="form-confirm-label">Итгэлтэй байна уу?</strong>
            <div class="tx-color-03 my-3">
              Нийт: {{ exam.Questions.length }} асуулт. Бөглөсөн:
              {{ exam.Questions.filter(x => x.isFilled).length }}. Бөглөөгүй:
              {{ exam.Questions.filter(x => !x.isFilled).length }}
            </div>
          </div>
          <div class="d-flex">
            <b-button
              variant="outline-danger"
              class="mr-3 ml-auto"
              @click="busy = false"
              >Үгүй</b-button
            >
            <b-button variant="outline-success" @click="finishForm(false)"
              >Тийм</b-button
            >
          </div>
        </div>
      </template>
    </b-overlay>
    <b-modal v-model="modalSecure" hide-footer title="Шалгалтын нууц үг">
      <div class="form-group">
        <label
          class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03"
          >Нууц үг</label
        >
        <input
          v-model="examPass"
          type="text"
          class="form-control"
          placeholder="Нууц үг оруулна уу"
        />
      </div>
      <div class="modal-footer pd-x-20 pd-t-15 pd-b-0">
        <button
          @click="modalSecure = false"
          type="button"
          class="btn btn-white"
          data-dismiss="modal"
        >
          Болих
        </button>
        <button @click="checkExamPass" type="button" class="btn btn-primary">
          Шалгах
        </button>
      </div>
    </b-modal>

    <Dialog
      :visible.sync="mdlAlert.show"
      title="Сануулга"
      footer-hide
      :transition-names="[]"
      :fullscreen="mdlAlert.fullscreen"
      :modal="false"
      :show-close="mdlAlert.closeable"
      :close-on-press-escape="mdlAlert.closeable"
      :close-on-click-modal="false"
    >
      <div class="text-center p-t-md">
        <div class="alert alert-warning" role="alert">
          <h4 class="alert-heading">Санамж</h4>
          <p>{{ mdlAlert.msg }}</p>
        </div>
        <!-- <div class="ivu-alert ivu-alert-warning ivu-alert-with-icon ivu-alert-with-desc">
          <span class="ivu-alert-icon">
            <i class="ivu-icon ivu-icon-ios-alert-outline"></i>
          </span>
          <span class="ivu-alert-message">Санамж</span>
          <span class="ivu-alert-desc">{{mdlAlert.msg}}</span>          
        </div>-->
      </div>
    </Dialog>
    <b-sidebar v-model="showRightSide" width="100%" right scrollable>
      <div class="bg-white pd-x-10 pd-y-5 bd-y">
        <div class="d-flex bd-b pd-b-5 mg-b-10">
          <div class="avatar">
            <img
              :src="$store.state.user.userInfo.avator"
              class="rounded-circle"
              alt
            />
          </div>
          <div class="mg-l-10">
            <h6 class="tx-semibold mg-b-0">
              {{ $store.state.user.userInfo.fullName }}
            </h6>
            <p class="tx-color-03 tx-12 mg-b-0">
              {{ $store.state.user.userInfo.groupName }}
            </p>
            <p class="tx-color-03 tx-12 mg-b-0">
              {{ $store.state.user.userInfo.position }}
            </p>
          </div>
        </div>
        <div v-if="mode == 2" class="text-center">
          <div class="tx-thin mg-b-5">шалгалт дуусахад</div>
          <vue-countdown
            @progress="timerProgress"
            @end="finishForm(false)"
            :time="getSeconds(exam.End)"
            v-slot="{ days, hours, minutes, seconds }"
            >{{ days }} өдөр : {{ hours }} цаг : {{ minutes }} минут :
            {{ seconds }} секунд</vue-countdown
          >
          <div class="mg-t-10">
            <button
              @click="busy = true"
              class="btn btn-xs btn-outline-danger"
              type="button"
            >
              Дуусгах
            </button>
          </div>

          <div class="container-fluid pd-y-10 bd-y mg-y-10">
            <div class="row" :key="fillingKey">
              <div
                :class="`d-flex align-items-center mg-b-5`"
                style="width: 12.5%"
                v-for="(q, qi) in exam.Questions"
                :key="qi"
              >
                <div
                  :class="
                    `bd rounded-circle ${
                      q.isFilled ? 'bg-primary text-white' : 'bg-gray-100'
                    } tx-12 pd-5`
                  "
                >
                  {{ qi + 1 >= 10 ? qi + 1 : "0" + (qi + 1) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import wordselect from "@/views/main/exam/wordselect.vue";

import { request } from "@/api/all";
import { localSave, localRead } from "@/libs/util";
import { romanize, alphabetize } from "@/libs/tools";
import VueCountdown from "@chenfengyuan/vue-countdown";
// const moment = require("moment");

const pako = require("pako");
import CryptoJS from "crypto-js";
var timer = "";

import "element-ui/lib/theme-chalk/index.css";
import { DatePicker, Input, Dialog, Notification } from "element-ui";
import { mapActions } from "vuex";
import Cookies from "js-cookie";
import Vue from "vue";
var _ = require("lodash");
const moment = require("moment");

export default {
  components: {
    DatePicker,
    Input,
    VueCountdown,
    vueCustomScrollbar,
    Dialog
  },
  props: {
    propExamId: {
      type: Number,
      default: () => 0
    },
    propCourseId: {
      type: Number,
      default: () => 0
    },
    ethicReportConfig: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      checkExamPassClicked: false,
      showRightSide: false,
      missingWordSelectRendered: false,
      fillingKey: 0,
      examId: "",
      exam: {},
      now: "",
      mode: null,
      formFilled: [],
      busy: false,
      processing: false,
      modalSecure: false,
      examPass: "",
      mdlAlert: {
        show: false,
        msg: "",
        closeable: true,
        fullscreen: false
      },
      pastSecond: 0,
      examHeight: 150,

      mainFormId: 0,
      mainCourseId: 0
    };
  },
  mounted() {
    window.addEventListener("keydown", this.handlerxx);
    this.mainFormId = this.$route.params.formId;
    //console.log('before', this.mainFormId);
    if (this.propExamId > 0) {
      this.mainFormId = this.propExamId;
      this.examHeight = window.innerHeight - 255;
    } else {
      this.examHeight = window.innerHeight - 55;
      let _obj = this.$store.state.app.mainLayoutConfig;
      _obj.aside = false;
      _obj.header = 0;
      _obj.footer = false;
      this.handleMainLayoutConfig(_obj);
    }

    this.mainCourseId = this.$route.params.courseId;
    if (this.$props.propCourseId > 0) {
      this.mainCourseId = this.$props.propCourseId;
    }

    let self = this;
    try {
      this.$store.state.signalr.osrCon.on(
        "onKickFromExam",
        (kickedFlag, msg) => {
          if (kickedFlag == 9000) {
            this.mdlAlert.show = true;
            this.mdlAlert.msg = msg;
            this.mdlAlert.closeable = false;
            this.mdlAlert.fullscreen = true;
            setTimeout(function() {
              self.finishForm(true);
            }, 500);
          } else {
            this.mdlAlert.show = true;
            this.mdlAlert.msg = msg;
            this.mdlAlert.closeable = true;
            this.mdlAlert.fullscreen = false;
          }
        }
      );
    } catch (error) {
      //console.log(error);
    }

    //Auth/RefreshToken
    //herev token_form_exam cookie bnuu uzeed bvl yaahchgui bhgui bol
    //Cookies.set('token_form_exam', token, { expires: config.cookieExpires || 1 });

    let examToken = Cookies.get(
      `token_for_exam_${this.$store.state.user.userId}`
    );
    if (examToken) {
      Cookies.set("token", examToken, { expires: 1 });
      this.tokenAfter();
    } else {
      request({
        api: { method: "POST", url: "Auth/RefreshToken" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          Cookies.set(
            `token_for_exam_${this.$store.state.user.userId}`,
            res.token,
            { expires: 1 }
          );
          Cookies.set("token", res.token, { expires: 1 });
          this.tokenAfter();
        }
      });
    }
  },

  methods: {
    ...mapActions(["handleMainLayoutConfig", "handleLoading"]),
    // requestGosmart(){
    //   // request({
    //   //   api: { method: "POST", url: "Auth/logout" },
    //   //   store: this.$store
    //   // });
    //   this.encryptData(JSON.stringify(this.formFilled));
    // },
    changeTarget(qId, gli) {
      //let drp = document.getElementById(`${qId}_${gli}_drp`);
      //console.log(drp);
      //let elem = document.getElementById(`${qId}_${gli}_mnu`);
      //console.log(elem)
      // elem.style.top = '100px';
      // elem.style.left = '100px';
      //document.body.appendChild(elem);
      // let drp = this.$refs[`${qId}_${gli}_drp`];
      // let mnu = this.$refs[`${qId}_${gli}_mnu`];
      // console.log(drp);
      // console.log(mnu);
      // document.body.appendChild(mnu);
    },
    handlerxx(e) {
      //console.log('corelist handler => ', e);
      if (
        e.key == "c" &&
        (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)
      ) {
        //console.log("return false mon uu");
        e.preventDefault();
        //return false;
      }
      if (
        e.key == "f" &&
        (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)
      ) {
        //console.log("return false mon uu");
        //return false;
        e.preventDefault();
      }
      if (
        e.keyCode == 83 &&
        (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)
      ) {
        //console.log("return false mon uu");
        //return false;
        e.preventDefault();
      }
    },
    tokenAfter() {
      this.examId = `exam_${this.mainFormId}_${this.mainCourseId}_${this.$store.state.user.userId}`;
      let _exists = localRead(this.examId);
      if (_exists) {
        this.exam = this.deCompress(_exists);
        //console.log(this.exam);

        let _filled = localRead(this.examId + "_filled");
        if (_filled) {
          this.formFilled = JSON.parse(_filled);
          this.$nextTick(() => {
            this.configureFilled();
          });
        }
        this.$nextTick(() => {
          this.configure();
        });
      } else {
        this.examInfo();
      }

      timer = setInterval(this.configure, 30000);
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    getSeconds(d) {
      // console.log('zorvv ni=> ', d, this.now);

      // //var startDate = new Date(this.now.toString().split("+")[0]+"+0000");

      // var sdate = new Date(this.now)
      // var userTimezoneOffset = sdate.getTimezoneOffset() * 60000;
      // var startDate = new Date(sdate.getTime() - userTimezoneOffset);
      // console.log("startDate", startDate);

      // //console.log(startDate1.getFullYear()+"-" + (parseInt(startDate1.getMonth())+parseInt(1)) +"-" + startDate1.getDate() +" "+ startDate1.getHours() +":"+ startDate1.getMinutes()+":"+startDate1.getSeconds());
      // //var startDate = Date.parse(startDate1.getFullYear()+"-" + startDate1.getMonth()+1 +"-" + startDate1.getDate() +" "+ startDate1.getHours() +":"+ startDate1.getMinutes()+":"+startDate1.getSeconds());

      // console.log(startDate);
      // // Do your operations
      // var endDate   = new Date(d);
      // //console.log(endDate.getTime());
      // var seconds = (endDate.getTime() - startDate.getTime()) / 1000;
      // var bSecond=Math.abs(seconds);
      // console.log('diffffffffffffffffffffffffffffffffff=> ',bSecond);
      // return bSecond*1000;
      // //return 120*1000;
      var a = moment(d);
      var b = moment(this.now.toString().split("+")[0]);

      return a.diff(b, "seconds") * 1000;

      //console.log(a.diff(b, 'seconds')*1000);
      //return 1000000;
      // let _range = new Date(d).getTime() - new Date(this.now).getTime();
      // return _range;
    },
    examInfo() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      //console.log('learn/getExamPreInfo ruu yavuulsan id ni', this.mainFormId);
      request({
        api: { method: "GET", url: "learn/getExamPreInfo" },
        params: {
          id: this.mainFormId,
          boxId: this.$route.params.boxId,
          lessonId: this.$route.params.lessonId
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('learn/getExamPreInfo learn/getExamPreInfo learn/getExamPreInfo', res);
          if (res.data.secure) {
            this.modalSecure = true;
          } else if (res.data.hasPayment) {
            if(res.data.invoiceId!=null && res.data.invoiceId!=undefined)
              this.$router.push(`/lms/paymentDetail/${res.data.invoiceId}`);
            else
              this.createInvoice(res.data.budget, res.data.invoiceBoxId);
          } else {
            this.init();
          }
        } else {
          this.$router.push({
            name: "lmsCourseView",
            params: { id: this.$route.params.courseId, bid: 0, iid: 0, bot: 0 }
          });
          //console.log(' getExamPreInfo res false orloo');
        }
      });
    },
    createInvoice(budget, lessonInvBoxId) {
      let _submitModel = {};

      let _projid = 0;
      let prj = this.$store.state.app.groupDefaultProjects.filter(
        x => x.objectTypeId == 343
      );
      if (prj.length > 0) _projid = prj[0].id;

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Task/GetInherited" },
        params: {
          id: 0,
          projectId: _projid,
          parentId: 0,
          boxId: lessonInvBoxId,
          objectTypeId: 343,
          userId: this.$store.state.user.userId
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          _submitModel = res.data.task;
          _submitModel.task = this.$store.state.user.userInfo.fullName;
          _submitModel.taskDesc = "Явцын шалгалтын төлбөр";
          _submitModel.budget = budget;
          //_submitModel.boxId= this.$route.params.boxId;
          _submitModel.defaultFormId = this.$route.params.formId;
          _submitModel.thirdOrganizationTaskId = this.$route.params.lessonId;
          _submitModel.fourthOrganizationTaskId = this.$route.params.courseId;
          //console.log('Task/GetInherited=> ', res);

          _submitModel.phone = `/exam/${this.$route.params.courseId}/${this.$route.params.formId}/${this.$route.params.lessonId}/${this.$route.params.boxId}/${this.$route.params.boxOt}`;

          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "POST", url: "Task/PostInherited" },
            data: { model: _submitModel },
            store: this.$store
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              //console.log('nehemjleh vvsleeeeeeeeeeeeeeeeeeeeee=> ', _submitModel.boxId, res.taskId);
              this.$router.push(`/lms/paymentDetail/${res.taskId}`);
            }
          });
        }
      });
    },
    checkExamPass() {

      let self= this;
      this.toggleBodyClass("addClass", "dynamic-locker");
      
      if(!this.checkExamPassClicked){
        this.checkExamPassClicked= true;
        // setTimeout(() => {
          request({
            api: { method: "GET", url: "learn/checkExamPass" },
            params: {
              id: self.mainFormId,
              pass: self.examPass
            },
            store: self.$store
          }).then(res => {
            self.checkExamPassClicked= false;
            self.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              self.modalSecure = false;
              self.init();
            }
          });
        // }, 3000);
      }
      
    },
    init() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "v2/Learn/GetExamData" },
        data: {
          id: this.mainFormId,
          courseId: this.mainCourseId,
          boxId: this.$route.params.boxId
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.downloadFromNetworkAfter();

          localSave(this.examId, res.data.form);
          this.exam = this.deCompress(res.data.form);
          this.$nextTick(() => {
            this.configure();
          });

          let _fillExists = localRead(this.examId + "_filled");
          if (!_fillExists) {
            this.formFilled = this.exam.Questions.map(e => {
              return {
                qId: e.qId,
                as: e.as.map(a => {
                  //console.log(a);
                  return {
                    a: "",
                    aId: a.aId,
                    g: a.g,
                    if: null,
                    s: "",
                    sec: null,
                    gg: null
                  };
                }),
                isFilled: null,
                sec: null
              };
            });
            localSave(this.examId + "_filled", JSON.stringify(this.formFilled));
          } else {
            this.formFilled = JSON.parse(_fillExists);
            this.$nextTick(() => {
              this.configureFilled();
            });
          }
        } else {
          localSave(this.examId + "_ban", "1");
          this.$router.push({ name: "home" });
        }
      });
    },
    downloadFromNetworkAfter() {
      request({
        api: { method: "POST", url: "learn/ExamDataSuccess" },
        data: { id: this.mainFormId },
        store: this.$store
      });
    },
    // configureCircleQuestionSelect(qId, gli){
    //   //${q.qId}_${gli}_cnt
    //   if(this.$refs[`${q.qId}_${gli}_cnt`].length){
    //     //console.log(this.$refs[`${q.qId}_${gli}_cnt`])
    //     //console.log(this.$refs[`${q.qId}_${gli}_drp`])
    //   }
    // },
    configure() {
      //console.log('v2/Learn/GetExamData', this.exam);
      request({
        api: { url: "isintime", method: "get" },
        params: {
          startDate: this.exam.Start,
          endDate: this.exam.End
        },
        store: self.$store
      }).then(res => {
        if (res != false) {
          if (res.data.mode == 1) {
            //# waiting
            this.mode = 1;
          } else if (res.data.mode == 0) {
            //# remaining shalgalt ehelsen yavj baina
            this.mode = 2;
            if (!this.missingWordSelectRendered) {
              this.$nextTick(() => {
                this.missingWordSelectRendered = true;
                this.exam.Questions.filter(x => x.t == 31).forEach(q => {
                  for (let k = 1; k <= q.agc; k++) {
                    //console.log(q.as.filter(x=>x.g==k));
                    let optns = q.as
                      .filter(x => x.g == k)
                      .map(answr => {
                        return {
                          aId: answr.aId,
                          a: answr.a,
                          isFilled: answr.if
                        };
                      });
                    this.createMissingWordSelect(q.qId, k, optns);
                  }
                });
                // this.exam.Questions.filter(x=>x.t == 34).forEach(q=>{
                //   for (let k=1; k<=4; k++) {
                //     this.configureCircleQuestionSelect(q.qId, k);
                //   }
                // });
              });
            }
          } else if (res.data.mode == -1) {
            this.finishForm(false);
            //# past
            this.mode = 3;
          }
          //console.log('olgoson nown', res.data.now);
          this.now = res.data.now;
          // if(moment(this.exam.end).isBefore(moment(this.now))){
          //   //# past
          //   this.mode= 3;
          //   this.finishForm(true);
          // } else if(moment(this.exam.start).isBefore(moment(this.now)) && moment(this.exam.end).isAfter(moment(this.now))){
          //   //# LIVE
          //   this.mode= 2;
          // }
          // else if(moment(this.exam.start).isAfter(moment(this.now))){
          //   //# FUTURE
          //   this.mode= 1;
          // }
        }
      });
    },
    configureFilled() {
      this.exam.Questions.forEach(q => {
        q.as.forEach(a => {
          let fq = this.formFilled.filter(w => w.qId == q.qId);
          if (fq.length) {
            let fa = fq[0].as.filter(z => z.aId == a.aId);
            if (fa.length > 0) {
              a.if = fa[0].if;
              a.s = fa[0].s;
              a.sec = fa[0].sec;
              a.gg = fa[0].gg;
              if (q.t == 7 || q.t == 21 || q.t == 22 || q.t == 1 || q.t == 11) {
                q.isFilled = a.s != null && a.s.length > 0;
              } else if (q.t == 3 || q.t == 4 || q.t == 23 || q.t == 24) {
                q.isFilled = q.as.filter(m => m.if == true).length > 0;
              } else if (q.t == 31) {
                q.isFilled = q.as.filter(m => m.if == true).length > 0;
              } else if (q.t == 32 || q.t == 33) {
                //console.log(fa);
                q.isFilled = q.as.length == q.as.filter(x => x.if).length;
              } else if (q.t == 34) {
                //console.log(fa);
                q.isFilled = !q.as.filter(x => !x.if && x.o != 0).length;
              }
            }
          }
        });
        //q.
      });
    },
    fillForm(q, a, gId, gg) {
      //let self= this;

      if (q.t == 7 || q.t == 21 || q.t == 22 || q.t == 1 || q.t == 11) {
        q.isFilled = q.as[0].s != null && q.as[0].s.length > 0;
        if (q.as[0].s != null && q.as[0].s.length > 0) a.sec = this.pastSecond;
      } else if (q.t == 3) {
        q.as.filter(x => x.aId == a.aId)[0].if = !a.if;
        q.as.filter(x => x.aId == a.aId)[0].sec = a.if ? this.pastSecond : null;
        q.isFilled = q.as.filter(x => x.if == true).length > 0;
      } else if (q.t == 4 || q.t == 23 || q.t == 24) {
        q.as.forEach(x => {
          x.if = x.aId == a.aId;
          x.sec = x.aId == a.aId ? this.pastSecond : null;
        });
        q.isFilled = q.as.filter(x => x.if == true).length > 0;
      } else if (q.t == 31) {
        if (a != null) {
          q.as
            .filter(x => x.g == a.g)
            .forEach(x => {
              x.if = x.aId == a.aId;
              x.sec = x.aId == a.aId ? this.pastSecond : null;
            });
        } else {
          q.as
            .filter(x => x.g == gId)
            .forEach(x => {
              x.if = false;
              x.sec = null;
            });
        }
        q.isFilled = q.as.filter(x => x.if).length;
        //console.log('missin word', q.as);
      } else if (q.t == 32 || q.t == 33) {
        this.handleLoading({ isLoading: true });
        a.if = gId == 0 ? false : true;
        a.s = a.if ? this.pastSecond : null;
        a.sec = a.if ? this.pastSecond : null;
        q.isFilled = q.as.length == q.as.filter(x => x.if).length;
        setTimeout(() => {
          this.handleLoading({ isLoading: false });
        }, 1000);
      } else if (q.t == 34) {
        this.handleLoading({ isLoading: true });
        if (a != null && q.as.filter(x => x.aId == a.aId).length) {
          // console.log(gg);
          if (q.as.filter(x => x.gg == gg).length) {
            q.as.filter(x => x.gg == gg)[0].if = null;
            q.as.filter(x => x.gg == gg)[0].sec = null;
            q.as.filter(x => x.gg == gg)[0].gg = null;
          }
          q.as.filter(x => x.aId == a.aId)[0].gg = gg;
          q.as.filter(x => x.aId == a.aId)[0].if = true;
          q.as.filter(x => x.aId == a.aId)[0].sec = this.pastSecond;
          //console.log('asuultiig olloo', q)
        } else {
          // console.log(gg);
          q.as.filter(x => x.gg == gg)[0].if = false;
          q.as.filter(x => x.gg == gg)[0].sec = null;
          q.as.filter(x => x.gg == gg)[0].gg = null;

          // q.as.filter(x=>x.aId==parseInt(gId.target.value, 10))[0].if=false;
          // q.as.filter(x=>x.aId==parseInt(gId.target.value, 10))[0].sec= 0;
        }

        q.isFilled = !q.as.filter(x => !x.if && x.o != 0).length;
        //console.log(q.isFilled);
        setTimeout(() => {
          this.handleLoading({ isLoading: false });
        }, 1000);
      }

      this.fillingKey++;

      this.formFilled = this.exam.Questions.map(e => {
        return {
          qId: e.qId,
          as: e.as.map(a => {
            return {
              a: a.a,
              aId: a.aId,
              g: a.g,
              sec: a.sec,
              if: a.if,
              s: a.s,
              gg: a.gg
            };
          }),
          isFilled: e.isFilled,
          sec: this.pastSecond
        };
      });
      localSave(this.examId + "_filled", JSON.stringify(this.formFilled));
    },
    finishForm() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      this.processing = true;

      let filled = this.formFilled.map(x => {
        return {
          qId: x.qId,
          tAwrs: x.as
        };
      });
      //console.log(JSON.stringify(filled));

      let encrypted = this.encryptData(JSON.stringify(filled));

      request({
        api: { method: "POST", url: "V2/learn/PostExamFilledData" },
        data: {
          model: {
            examid: this.exam.Id,
            finishedAt: 0,
            userid: this.$store.state.user.userId,
            encrypted: encrypted,
            Questions: [],
            //finishByAuto: finishByAuto
            finishByAuto: false
          }
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.showRightSide = false;
          this.processing = false;
          this.busy = false;
          window.localStorage.removeItem(this.examId);
          window.localStorage.removeItem(this.examId + "_filled");
          window.localStorage.removeItem(this.examId + "_filled");
          Cookies.remove(`token_for_exam_${this.$store.state.user.userId}`);
          clearInterval(timer);
          this.mode = 3;

          if (this.propExamId > 0) {
            this.finishAfter();
          }
        } else {
          clearInterval(timer);
          this.mode = 5;
          this.processing = false;
          this.busy = false;
        }
      });
    },
    finishAfter() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "learn/GetLessonExamResult" },
        params: { examId: this.propExamId },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");

        if (res != false) {
          let _results = _.orderBy(res.data.results, ["perc"], ["desc"]);
          //console.log('GetLessonExamResult', res, this.ethicReportConfig.fl1)
          if (
            _results.length > 0 &&
            _results[0].perc >= this.ethicReportConfig.fl1
          ) {
            Notification.success({
              title: `Амжилттай`,
              message: `Таны оноо ${_results[0].perc.toFixed(2)}`,
              duration: 5000,
              type: "success",
              position: "top-right",
              offset: 50
            });
            this.$emit("on-congrats");
          } else {
            Notification.warning({
              title: `${this.ethicReportConfig.fl1} хувиар тэнцэнэ !`,
              message: `Таны оноо ${_results[0].perc.toFixed(2)}`,
              duration: 5000,
              type: "warning",
              position: "top-right",
              offset: 50
            });
            this.tokenAfter();
          }
        } else {
          this.tokenAfter();
        }
      });
    },
    timerProgress(e) {
      let _range =
        new Date(this.exam.End).getTime() - new Date(this.exam.Start).getTime();
      this.pastSecond = _range / 1000 - e.totalSeconds;
    },

    decryptData(data) {
      var Pass = CryptoJS.enc.Utf8.parse(data.substring(0, 22));
      var encryptData = data.substring(22, data.length);
      try {
        var iv = CryptoJS.enc.Hex.parse("e84ad660c4721ae0e84ad660c4721ae0");
        var Salt = CryptoJS.enc.Utf8.parse("u2m9d2dfds1xS!2");
        var key128Bits1000Iterations = CryptoJS.PBKDF2(
          Pass.toString(CryptoJS.enc.Utf8),
          Salt,
          { keySize: 128 / 32, iterations: 1000 }
        );
        var cipherParams = CryptoJS.lib.CipherParams.create({
          ciphertext: CryptoJS.enc.Base64.parse(encryptData)
        });
        var decrypted = CryptoJS.AES.decrypt(
          cipherParams,
          key128Bits1000Iterations,
          { mode: CryptoJS.mode.CBC, iv: iv, padding: CryptoJS.pad.Pkcs7 }
        );
        return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
      } catch (ex) {
        return null;
      }
    },
    makeid(length) {
      var result = [];
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result.push(
          characters.charAt(Math.floor(Math.random() * charactersLength))
        );
      }
      return result.join("");
    },
    encryptData(data) {
      CryptoJS.pad.NoPadding = { pad: function() {}, unpad: function() {} };
      let Pass = this.makeid(22);
      var text = data;
      var Salt = CryptoJS.enc.Utf8.parse("u2m9d2dfds1xS!2");
      var key128Bits1000Iterations = CryptoJS.PBKDF2(
        Pass.toString(CryptoJS.enc.Utf8),
        Salt,
        { keySize: 128 / 32, iterations: 1000 }
      );
      var iv = CryptoJS.enc.Hex.parse("e84ad660c4721ae0e84ad660c4721ae0");
      var encrypted = CryptoJS.AES.encrypt(text, key128Bits1000Iterations, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7
      });
      return Pass + encrypted;
    },
    deCompress(data) {
      let binary = atob(data);
      let bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
      bytes = bytes.slice(4);
      let inflated = pako.inflate(bytes);

      //let message = String.fromCharCode.apply(null, inflated);
      //let message = String.fromCharCode.apply(null, new Uint8Array(inflated))
      let message = new Uint8Array(inflated).reduce(function(data, byte) {
        return data + String.fromCharCode(byte);
      }, "");

      var decrypted = this.decryptData(message);
      if (decrypted != null) {
        return decrypted;
      } else return null;
    },
    _arrayBufferToBase64(buffer) {
      var binary = "";
      var bytes = new Uint8Array(buffer);
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    },
    romanize(v) {
      return romanize(v);
    },
    alphabetize(v) {
      return alphabetize(v);
    },
    createMissingWordSelect(qId, gId, answers) {
      var ComponentClass = Vue.extend(wordselect);
      var instance = new ComponentClass({
        propsData: {
          gId: gId,
          qId: qId,
          answers: answers
        },
        parent: this
      });
      instance.$;
      //instance.$slots.default = ["Click me!"];
      instance.$mount(); // pass nothing
      instance.$on("change", e => this.missingChanged(e));
      document.getElementById(`q_${qId}_${gId}`).appendChild(instance.$el);
    },
    generateMissingWords(q) {
      let rv = q.q;
      for (let k = 1; k <= q.agc; k++) {
        let bldr = `<span id='q_${q.qId}_${k}'></span>`;
        rv = rv.replace("{" + k + "}", bldr);
      }
      return rv;
    },
    missingChanged(obj) {
      let _q = this.exam.Questions.filter(x => x.qId == obj.qId);
      //console.log(obj);
      if (_q.length) {
        _q = _q[0];
        let _a = _q.as.filter(x => x.aId == obj.aId);
        if (_a.length) {
          _a = _a[0];
          this.fillForm(_q, _a);
        } else {
          this.fillForm(_q, null, obj.gId);
        }
      }
    },
    sortedAnswers(q) {
      let rv = [];
      rv = _.orderBy(q.as, ["s"], ["asc"]);
      return rv;
    }
  },
  beforeDestroy() {
    clearInterval(timer);
    window.removeEventListener("keydown", this.handlerxx);
  }
};
</script>

<style lang="scss">
.section-alert {
  p {
    margin-bottom: 0;
  }
}
.number-with-pend {
  .el-input {
    margin-top: -1px;
    .el-input__inner {
      height: 38px;
      line-height: 38px;
    }
  }
  .missing-select {
    font-style: italic;
    option {
      padding: 0 10px !important;
      text-decoration: underline !important;
    }
  }
}

.pyramid {
  float: left;
  shape-outside: polygon(310px 0px, 130px 405px, 558px 405px);
  width: 100%;

  .zone {
    height: 100px;
    margin: 5px auto 0 auto;
    text-align: center;
    color: black;
    background-blend-mode: darken;
    transition: 0.5s;
  }
  .zone:nth-child(1) {
    background: rgba(0, 0, 0, 0.1);
    width: 25%;
    clip-path: url("#part1");
    clip-path: polygon(50% 0%, 100% 100%, 0% 100%);
    -webkit-clip-path: polygon(50% 0%, 100% 100%, 0% 100%);
  }
  .zone:nth-child(2) {
    background: rgba(0, 0, 0, 0.2);
    width: 50%;
    clip-path: url("#part2");
    clip-path: polygon(25% 0%, 75% 0, 100% 100%, 0% 100%);
    -webkit-clip-path: polygon(25% 0%, 75% 0, 100% 100%, 0% 100%);
  }
  .zone:nth-child(3) {
    width: 75%;
    background: rgba(0, 0, 0, 0.3);
    clip-path: url("#part3");
    clip-path: polygon(16.5% 0, 83% 0, 100% 100%, 0% 100%);
    -webkit-clip-path: polygon(16.5% 0, 83% 0, 100% 100%, 0% 100%);
  }
  .zone:nth-child(4) {
    background: rgba(0, 0, 0, 0.4);
    width: 100%;
    clip-path: url("#part4");
    clip-path: polygon(12.5% 0, 0%, 87.5% 0, 100% 100%, 0% 100%);
    -webkit-clip-path: polygon(12.5% 0, 87.5% 0, 100% 100%, 0% 100%);
  }
  // .zone:nth-child(5){
  //   background:rgba(0,0,0,0.5);
  //   width: 62.5%;
  //   clip-path:url("#part5");
  //   clip-path:polygon(9.5% 0, 0%,90.5% 0, 100% 100%,0% 100%);
  //   -webkit-clip-path:polygon(9.5% 0,90.5% 0, 100% 100%,0% 100%);
  // }
  // .zone:nth-child(6){
  //   background:rgba(0,0,0,0.5);
  //   width: 75%;
  //   clip-path:url("#part6");
  //   clip-path:polygon(7.5% 0, 0%,92% 0, 100% 100%,0% 100%);
  //   -webkit-clip-path:polygon(8% 0,92% 0, 100% 100%,0% 100%);
  // }
  // .zone:nth-child(7){
  //   background:rgba(0,0,0,0.5);
  //   width: 87.5%;
  //   clip-path:url("#part7");
  //   clip-path:polygon(7% 0, 0%,93% 0, 100% 100%,0% 100%);
  //   -webkit-clip-path:polygon(7% 0,93% 0, 100% 100%,0% 100%);
  // }
  // .zone:nth-child(8){
  //   background:rgba(0,0,0,0.5);
  //   width: 100%;
  //   clip-path:url("#part8");
  //   clip-path:polygon(6% 0, 0%,94% 0, 100% 100%,0% 100%);
  //   -webkit-clip-path:polygon(6% 0,94% 0, 100% 100%,0% 100%);
  // }
  .zone:hover {
    background-color: rgba(255, 0, 0, 0.3);
    color: white;
  }
}

.on-mobile {
  .wd-500 {
    width: 100% !important;
  }
  .square-group-loop-outer {
    .col-6:nth-child(1) {
      .drpdwn {
        top: 30px;
        left: 10px;
        z-index: 9;
        position: absolute;
        .btn {
          width: 150px;
          overflow: hidden;
        }
      }
      .sction {
        width: 100% !important;
        top: 5px !important;
        left: -5px !important;
        //right: 5px !important;
        .cmbo {
          position: absolute !important;
          top: 20px !important;
          left: 0 !important;
          .dd {
            top: 20px !important;
            left: 20px !important;
          }
        }
        .dugui {
          background: #10b759 !important;
          right: -150px !important;
          bottom: -150px !important;
          .txt {
            text-align: right;
            bottom: 150px;
            position: absolute;
          }
        }
      }
    }
    .col-6:nth-child(2) {
      .drpdwn {
        top: 30px;
        right: 10px;
        z-index: 9;
        position: absolute;
        .btn {
          width: 150px;
          overflow: hidden;
        }
      }
      .sction {
        width: 100% !important;
        top: 5px !important;
        right: -5px !important;
        .cmbo {
          position: absolute !important;
          top: 20px !important;
          right: 0 !important;
          .dd {
            top: 20px !important;
            right: 20px !important;
          }
        }
        .dugui {
          background: #00b8d4 !important;
          left: -150px !important;
          bottom: -150px !important;
          .txt {
            text-align: left;
            left: 150px;
            bottom: 150px;
            position: absolute;
          }
        }
      }
    }
    .col-6:nth-child(3) {
      .drpdwn {
        bottom: 30px;
        left: 10px;
        z-index: 9;
        position: absolute;
        .btn {
          width: 150px;
          overflow: hidden;
        }
      }
      .sction {
        width: 100% !important;
        bottom: 5px !important;
        left: -5px !important;
        .cmbo {
          position: absolute !important;
          bottom: 20px !important;
          left: 0 !important;
          .dd {
            bottom: 20px !important;
            left: 20px !important;
          }
        }
        .dugui {
          background: #ffc107 !important;
          right: -150px !important;
          top: -150px !important;
          .txt {
            text-align: right;
            top: 150px;
            position: absolute;
          }
        }
      }
    }
    .col-6:nth-child(4) {
      .drpdwn {
        bottom: 30px;
        right: 10px;
        z-index: 9;
        position: absolute;
        .btn {
          width: 150px;
          overflow: hidden;
        }
      }
      .sction {
        width: 100% !important;
        bottom: 5px !important;
        right: -5px !important;
        .cmbo {
          position: absolute !important;
          bottom: 20px !important;
          right: 0 !important;
          .dd {
            bottom: 20px !important;
            right: 20px !important;
          }
        }
        .dugui {
          background: #3b4863 !important;
          left: -150px !important;
          top: -150px !important;
          .txt {
            color: white !important;
            text-align: left;
            left: 150px;
            top: 150px;
            position: absolute;
          }
        }
      }
    }
  }
}
.square-group-loop-outer {
  .col-6:nth-child(1) {
    .drpdwn {
      top: 30px;
      left: 10px;
      z-index: 9;
      position: absolute;
      .btn {
        width: 150px;
        overflow: hidden;
      }
    }
    .sction {
      top: 0 !important;
      left: 0 !important;
      .cmbo {
        position: absolute !important;
        top: 20px !important;
        left: 0 !important;
        .dd {
          top: 20px !important;
          left: 20px !important;
        }
      }
      .dugui {
        background: #10b759 !important;
        right: -150px !important;
        bottom: -150px !important;
        .txt {
          text-align: right;
          bottom: 150px;
          position: absolute;
        }
      }
    }
  }
  .col-6:nth-child(2) {
    .drpdwn {
      top: 30px;
      right: 10px;
      z-index: 9;
      position: absolute;
      .btn {
        width: 150px;
        overflow: hidden;
      }
    }
    .sction {
      top: 0 !important;
      right: 0 !important;
      .cmbo {
        position: absolute !important;
        top: 20px !important;
        right: 0 !important;
        .dd {
          top: 20px !important;
          right: 20px !important;
        }
      }
      .dugui {
        background: #00b8d4 !important;
        left: -150px !important;
        bottom: -150px !important;
        .txt {
          text-align: left;
          left: 150px;
          bottom: 150px;
          position: absolute;
        }
      }
    }
  }
  .col-6:nth-child(3) {
    .drpdwn {
      bottom: 30px;
      left: 10px;
      z-index: 9;
      position: absolute;
      .btn {
        width: 150px;
        overflow: hidden;
      }
    }
    .sction {
      bottom: 0 !important;
      left: 0 !important;
      .cmbo {
        position: absolute !important;
        bottom: 20px !important;
        left: 0 !important;
        .dd {
          bottom: 20px !important;
          left: 20px !important;
        }
      }
      .dugui {
        background: #ffc107 !important;
        right: -150px !important;
        top: -150px !important;
        .txt {
          text-align: right;
          top: 150px;
          position: absolute;
        }
      }
    }
  }
  .col-6:nth-child(4) {
    .drpdwn {
      bottom: 30px;
      right: 10px;
      z-index: 9;
      position: absolute;
      .btn {
        width: 150px;
        overflow: hidden;
      }
    }
    .sction {
      bottom: 0 !important;
      right: 0 !important;
      .cmbo {
        position: absolute !important;
        bottom: 20px !important;
        right: 0 !important;
        .dd {
          bottom: 20px !important;
          right: 20px !important;
        }
      }
      .dugui {
        background: #3b4863 !important;
        left: -150px !important;
        top: -150px !important;
        .txt {
          color: white !important;
          text-align: left;
          left: 150px;
          top: 150px;
          position: absolute;
        }
      }
    }
  }
}
</style>
